import { cx } from '@linaria/core';
import { checkboxMediaInput } from '@utils/component-framework';
import { useOpgavekompleksetEntry } from '../../../../state/hook.entry.js';
import { useUpdateInputMutation } from '../../../../state/mutations/update-input.js';
import { CircledAudioPlayer } from '../../../atom.audio/_audio-player.circled.js';
import { useInputState } from '../../hook.use-input-state.js';
import { MediaBox } from '../atom.media-box/_media-box.js';
import { player, box } from './input.audio.style.js';
import { jsx } from 'react/jsx-runtime';

function AudioInput(props) {
  const update = useUpdateInputMutation();
  const inputEntry = useOpgavekompleksetEntry({
    select: entry => checkboxMediaInput.entry.asType(entry?.data.tasks[props.taskEntryKey]?.details[props.node.id])
  });
  const onChange = () => {
    update(props.taskEntryKey, props.node.id, {
      type: "checkbox-media",
      markedAsCorrectAnswer: !inputEntry?.markedAsCorrectAnswer
    });
  };
  const baseState = useInputState(props.node, inputEntry);
  const state = (() => {
    if (baseState === "incorrect" && !inputEntry?.markedAsCorrectAnswer && props.node.correctAnswer) {
      return "should-have";
    }
    return baseState;
  })();
  return /*#__PURE__*/jsx(MediaBox, {
    className: cx(box, props.orientation),
    checked: !!inputEntry?.markedAsCorrectAnswer,
    state: state,
    onChange: onChange,
    orientation: props.orientation,
    theme: "squared",
    children: /*#__PURE__*/jsx(CircledAudioPlayer, {
      size: "large",
      className: player,
      src: props.node.src
    })
  });
}

export { AudioInput };
//# sourceMappingURL=input.audio.js.map
